export const cleanTiptapOutput = (html: string): string => {
  if (!html) return ''

  // Create a temporary DOM parser
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')

  // 1. Remove <colgroup> elements
  const colgroups = doc.querySelectorAll('colgroup')
  colgroups.forEach(cg => cg.remove())

  // 2. Clean up tables
  const tables = doc.querySelectorAll('table')
  tables.forEach(table => {
    // Remove min-width style usually added by Tiptap
    table.style.removeProperty('min-width')
    
    // Convert RGB background-color to Hex for consistency and better email support
    const bgColor = table.style.backgroundColor
    if (bgColor && bgColor.startsWith('rgb')) {
      const hex = rgbToHex(bgColor)
      if (hex) table.style.backgroundColor = hex
    }
  })

  // 3. Remove redundant attributes from cells
  const cells = doc.querySelectorAll('td, th')
  cells.forEach(cell => {
    if (cell.getAttribute('colspan') === '1') cell.removeAttribute('colspan')
    if (cell.getAttribute('rowspan') === '1') cell.removeAttribute('rowspan')
  })

  // 4. Remove empty paragraphs that add unwanted space
  const paragraphs = doc.querySelectorAll('p')
  paragraphs.forEach(p => {
    const text = p.textContent?.trim() || ''
    const hasChildren = p.children.length > 0
    // If it's truly empty, remove it. 
    // BUT be careful with cells that only have one p.
    if (!text && !hasChildren && p.parentNode?.nodeName !== 'TD') {
      p.remove()
    }
  })

  // 5. Return serialized HTML
  return doc.body.innerHTML
}

// Helper to convert rgb(r, g, b) to #rrggbb
const rgbToHex = (rgb: string): string | null => {
  const match = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)
  if (!match) return null
  const r = parseInt(match[1])
  const g = parseInt(match[2])
  const b = parseInt(match[3])
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()
}
